export const SW_VERSION = '1.8'
